import { useIonRouter } from '@ionic/react'
import { LogoText, Page } from '@/styles/pages/Intro'
import TisitWordmark from '@assets/icons/tisit_logo_full.svg'
import { useEffect } from 'react'
import { ROUTES } from '@shared/constants/routes'
import { authTokenStorage } from '@shared/lib/authTokenStorage'

const STORAGE_RETRY_DELAY_MS = 3_000
const TOKEN_EXPIRY_LEEWAY_MS = 30_000

const hasUsableToken = (
	token: string | null | undefined,
	expiresAt: number | null | undefined,
	isJwtExpired: (token: string) => boolean
): boolean => {
	if (!token) return false
	return expiresAt === null || expiresAt === undefined
		? !isJwtExpired(token)
		: Date.now() + TOKEN_EXPIRY_LEEWAY_MS < expiresAt
}

export default function Intro() {
	const nav = useIonRouter()

	useEffect(() => {
		let cancelled = false
		let retryTimer: number | null = null

		const checkUserStatus = async () => {
			try {
				const tokens = await authTokenStorage.getTokens()
				if (cancelled) return

				const hasValidAccessToken = hasUsableToken(
					tokens?.accessToken,
					tokens?.accessExpiresAt,
					token => authTokenStorage.isAccessTokenExpired(token)
				)
				const hasValidRefreshToken = hasUsableToken(
					tokens?.refreshToken,
					tokens?.refreshExpiresAt,
					token => authTokenStorage.isRefreshTokenExpired(token)
				)

				if (hasValidAccessToken || hasValidRefreshToken) {
					nav.push(ROUTES.auth.enterBaseInfo)
					return
				}

				nav.push(ROUTES.overall.hello)
			} catch {
				if (!cancelled) {
					retryTimer = window.setTimeout(
						() => void checkUserStatus(),
						STORAGE_RETRY_DELAY_MS
					)
				}
			}
		}

		void checkUserStatus()

		return () => {
			cancelled = true
			if (retryTimer !== null) window.clearTimeout(retryTimer)
		}
	}, [nav])

	return (
		<Page>
			<LogoText src={TisitWordmark} />
		</Page>
	)
}
